<template>
  <div class="login">

    <div class="login_head">
      <img :src="$_c + 'img/mobile/login_bg.png'"/>
      <div class="box">
        <img :src="$_c + 'img/mobile/logo.png'"/>
        <p>欢迎登录专家管理系统！</p>
      </div>
    </div>
    <a-form :form="form"
            @submit="onSubmit" style="margin: 30px">
      <a-form-item>
        <a-input size="large"
                 placeholder="请输入要绑定的手机号码"
                 v-decorator="['mobile', {rules: [{ required: true, message: '请输入要绑定的手机号码', whitespace: true}]}]">
          <a-icon slot="prefix"
                  type="mobile"/>
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-row :gutter="8">
          <a-col :span="14">
            <a-input size="large"
                     placeholder="验证码"
                     v-decorator="['code', {rules: [{ required: true,message: '请输入验证码', whitespace: true}]}]">
              <a-icon slot="prefix"
                      type="mail"/>
            </a-input>
          </a-col>
          <a-col :span="10">
            <a-button block @click="requestCode()"
                      :disabled="disabled"
                      size="large">{{ btnText }}
            </a-button>
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item>
        <a-button :loading="submitLoading"
                  style="width: 100%;margin-top: 24px"
                  size="large"
                  htmlType="submit"
                  type="primary">提交绑定
        </a-button>
      </a-form-item>
    </a-form>
    <div class="footer">{{ title }}</div>
  </div>
</template>

<script>
import {
  GetVerificationCodeByExpertLogin,
  WeChatBindMobilePhone,
  WeChatLogin,
  WeChatRebindOpenId
} from '@/views/login/api/LoginApi'
import { SYS_TITLE } from '@/store/mutation-types'
import { AUTH_FLAG } from '@/views/login/util/WeChatUtil'

export default {
  name: 'WeChatBindMobilePhoneModal',
  data () {
    return {
      submitLoading: false,
      form: this.$form.createForm(this),
      btnText: '获取验证码',
      disabled: false,
      openId: '',
      title: this.$ls.get(SYS_TITLE),
    }
  },
  methods: {
    init (openId) {
      this.openId = openId
    },
    async requestCode () {
      let mobile = this.form.getFieldValue('mobile')
      if (!mobile) {
        this.$warning({
          title: '请输入要绑定的手机号码！'
        })
        return
      }
      const that = this
      this.disabled = true
      this.btnText = '请稍候...'
      try {
        let res = await GetVerificationCodeByExpertLogin(mobile)
        if (res.code !== 200) {
          that.$error({ title: '提示', content: res.msg })
          that.btnText = '获取验证码'
          that.disabled = false
          return
        }
        that.$message.success(res.msg)
        setTimeout(() => {
          let seconds = 60
          that.btnText = seconds + 's后获取'
          let countdown = setInterval(() => {
            if (seconds > 0) {
              that.btnText = seconds + 's后获取'
              --seconds
            } else {
              that.btnText = '获取验证码'
              that.disabled = false
              clearInterval(countdown)
            }
          }, 1000)
        }, 500)
      } catch (e) {
        that.$message.error(e.message)
      }
    },
    onSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        this.onHandleBindPhone(values)
      })
    },
    async onHandleBindPhone (values) {
      let that = this
      this.submitLoading = true
      const res = await WeChatBindMobilePhone({ mobilePhone: values.mobile, code: values.code, openId: this.openId })
      if (res.code === 200) {
        this.$message.success('绑定成功')
        this.$emit('success', values)
      } else if (res.code === 401) {
        this.$error({
          title: '提示',
          content: res.msg,
          okText: '重新授权',
          onOk () {
            WeChatLogin().then((res) => {
              if (res.code === 200) {
                window.location.href = res.msg
              }
            })
          }
        })
      } else if (res.code === 402) {
        this.$confirm({
              title: '提示',
              content: '您的账号已经绑定了另外一个微信号，是否解绑该微信号并重新绑定到当前微信号？',
              okText: '重新授权',
              cancelText: '不重新绑定',
              async onOk () {
                let res2 = await WeChatRebindOpenId({ mobilePhone: values.mobile, openId: that.openId })
                if (res2.code === 200) {
                  that.$message.success('绑定成功')
                  that.$emit('success', values)
                } else if (res2.code === AUTH_FLAG.FAIL) {
                  WeChatLogin().then((res) => {
                    if (res.code === 200) {
                      window.location.href = res.msg
                    }
                  })
                } else {
                  that.$error({
                    title: '提示',
                    content: res.msg,
                  })
                }
              },
              onCancel () {
                that.$emit('success', values)
              }
            }
        )
      } else {
        this.$error({
          title: '提示',
          content: res.msg,
        })
      }
      this.submitLoading = false
    },

  }
  ,
}
</script>
<style lang="less" scoped>
.login {
  min-height: 100vh;

  .footer {
    position: absolute;
    bottom: 20px;
    right: 0;
    left: 0;
    text-align: center;
  }
}

.login_head {
  position: relative;

  img {
    width: 100%;
    display: block;
  }

  .box {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    text-align: center;
    color: #fff;
    font-size: 18px;

    img {
      width: 72px;
      margin: 12% auto 7% auto;
    }
  }
}
</style>
